module.exports = __webpack_public_path__ + "img/cancel.232f1d11.svg";